// Auth Spy - Tracks all signOut calls to identify the source
import { supabase } from "@/integrations/supabase/client";

// Store original signOut method
const originalSignOut = supabase.auth.signOut.bind(supabase.auth);

// Track signOut calls with stack traces
export const instrumentAuthSignOut = () => {
  // Override signOut method with tracking
  supabase.auth.signOut = async (options?: any) => {
    const stack = new Error().stack;
    const path = window.location.pathname;
    const onRestrictedPage = path === '/suspended' || path === '/deactivated';
    const allowOverride = options?.__allowOnRestricted === true || options?.__lovAllow === true || options?.force === true;

    console.log('[AuthSpy] signOut() called!', {
      timestamp: new Date().toISOString(),
      options,
      onRestrictedPage,
      stack: stack?.split('\n').slice(1, 10), // First 10 lines of stack trace
      url: window.location.href,
      userAgent: navigator.userAgent.slice(0, 100)
    });

    // Guard: prevent silent sign-outs while on suspended/deactivated page unless explicitly allowed
    if (onRestrictedPage && !allowOverride) {
      console.warn('[AuthSpy] signOut blocked on restricted page. Use __allowOnRestricted to override.', { path });
      return { error: null } as any;
    }
    
    // Call original signOut
    return originalSignOut(options);
  };
  
  console.log('[AuthSpy] Instrumentation activated - tracking all signOut calls');
};

// Track storage events that might indicate external signout
export const trackStorageEvents = () => {
  const originalSetItem = localStorage.setItem.bind(localStorage);
  const originalRemoveItem = localStorage.removeItem.bind(localStorage);
  
  localStorage.setItem = (key: string, value: string) => {
    if (key.includes('supabase')) {
      console.log('[AuthSpy] localStorage.setItem:', { key, value: value.slice(0, 100) + '...' });
    }
    return originalSetItem(key, value);
  };
  
  localStorage.removeItem = (key: string) => {
    if (key.includes('supabase')) {
      console.log('[AuthSpy] localStorage.removeItem:', { key });
    }
    return originalRemoveItem(key);
  };
  
  // Listen for storage events from other tabs
  window.addEventListener('storage', (event) => {
    if (event.key?.includes('supabase')) {
      console.log('[AuthSpy] Storage event from another tab:', {
        key: event.key,
        oldValue: event.oldValue?.slice(0, 100) + '...',
        newValue: event.newValue?.slice(0, 100) + '...',
        url: event.url
      });
    }
  });
  
  console.log('[AuthSpy] Storage tracking activated');
};